export default __webpack_public_path__ + "static/media/nav-contact.20d21221.svg";